import styled from "styled-components"

export const Page = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
`

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`

export const Content = styled.div`
  flex-grow: 1;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`

export const Flex = styled.div`
  display: flex;
  flex: ${({ grow }) => grow || 0} ${({ shrink }) => shrink || 0}
    ${({ basis }) => basis || "auto"};
  flex-direction: ${({ direction }) => direction || "row"};
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
`

export const LayerStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Layer = styled.div`
  padding: 1rem 0;
  border-top: 1px solid ${props => props.theme.secondary};
  width: 100%;
  flex-shrink: 0;
  flex-grow: 1;
  display: flex;
  min-height: 20rem;
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/UI/Page/index.js